const state = {
  offset: 0,
};

const getters = {
  getOffset: (state) => state.offset,
};
const actions = {};

const mutations = {
  SET_OFFSET(state, offset) {
    state.offset = offset;
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
